<div class="flex flex-col gap-6">
  <section class="rounded-3xl bg-lGray900 px-5 py-7 sm:px-8">
    <h2 class="mb-6 text-xl font-semibold text-lWhite">Redefinir senha</h2>

    <form id="profile-password-form" class="flex w-full max-w-lg flex-col gap-6" [formGroup]="form" (ngSubmit)="submit()">
      <p-floatlabel variant="on">
        <input
          pInputText
          id="currentPassword"
          type="password"
          formControlName="currentPassword"
          autocomplete="current-password"
          class="w-full !pr-11"
          [type]="hideCurrentPassword ? 'password' : 'text'"
        />
        <label for="currentPassword">Senha atual</label>
        <button
          type="button"
          class="absolute right-3 top-1/2 z-10 flex -translate-y-1/2 text-lWhite"
          aria-label="Mostrar senha atual"
          (click)="hideCurrentPassword = !hideCurrentPassword"
        >
          <l-icon>{{ hideCurrentPassword ? 'visibility_off' : 'visibility' }}</l-icon>
        </button>
      </p-floatlabel>

      <p-floatlabel variant="on">
        <input
          pInputText
          id="newPassword"
          type="password"
          formControlName="newPassword"
          autocomplete="new-password"
          class="w-full !pr-11"
          [type]="hideNewPassword ? 'password' : 'text'"
        />
        <label for="newPassword">Nova senha</label>
        <button
          type="button"
          class="absolute right-3 top-1/2 z-10 flex -translate-y-1/2 text-lWhite"
          aria-label="Mostrar nova senha"
          (click)="hideNewPassword = !hideNewPassword"
        >
          <l-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</l-icon>
        </button>
      </p-floatlabel>

      <p-floatlabel variant="on">
        <input
          pInputText
          id="confirmPassword"
          type="password"
          formControlName="confirmPassword"
          autocomplete="new-password"
          class="w-full !pr-11"
          [type]="hideConfirmPassword ? 'password' : 'text'"
        />
        <label for="confirmPassword">Confirmar senha</label>
        <button
          type="button"
          class="absolute right-3 top-1/2 z-10 flex -translate-y-1/2 text-lWhite"
          aria-label="Mostrar confirmação da senha"
          (click)="hideConfirmPassword = !hideConfirmPassword"
        >
          <l-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</l-icon>
        </button>
      </p-floatlabel>

      <l-password-feedback
        class="!pt-0"
        [password]="form.controls.newPassword.value"
        [confirmPassword]="form.controls.confirmPassword.value"
      />
    </form>
  </section>

  <div class="flex flex-col sm:flex-row sm:justify-end">
    <button
      lButton
      [bType]="buttonTypeEnum.PRIMARY"
      [bRadius]="buttonRadiusEnum.CIRCLE"
      type="submit"
      form="profile-password-form"
      [disabled]="isLoading"
      class="sm:!w-56"
    >
      {{ isLoading ? 'Salvando...' : 'Salvar alterações' }}
    </button>
  </div>
</div>
